<template>
  <div class="row slim-grid-row mb-3-1 rounded-6 py-2 bg-white" style="box-shadow: #0000000d 0px 5px 30px 0px">
    <!-- <div :id="data.id" class="position-relative" style="top: -120px"></div> -->
    <div class="col-3" @click="openDetail">
      <div class="position-relative w-100">
        <img :src="data.image_url" class="rounded-10 img-list-room-dining object-fit w-100">
        <p class="mb-0 badge-variant body-3-3 text-white" v-if="is_variant">{{data.variant_list.length}} {{data.variant_list.length > 1 ? 'variants' : 'variant'}}</p>
      </div>
    </div>
    <div class="col-9">
      <p class="mb-0 body-2-2 font-bold text-truncate" @click="openDetail">{{data.name}}</p>
      <div class="row slim-grid-row">
        <div class="align-self-end" :class="{'col-8': qtyCart == 0 || !is_variant, 'col-7': qtyCart > 0 && is_variant}">
          <div style="height: 21px;">
            <p class="mb-0 body-2-2-1 text-truncate pr-4" @click="openDetail">{{data.description}}</p>
          </div>
          <p v-if="is_decrease_promo" class="mb-0 ls-0-1 text-14 text-light-menu text-line-through d-inline-block align-middle">{{formatCurrency(promotion_price)}}</p>
          <p class="mb-0 body-2-2 text-truncate d-inline-block text-orange font-bold align-middle">{{formatCurrency(final_price)}}</p>
        </div>
        <!-- <div class="col-3 text-right" v-if="data.variant_list.length > 0">
          <button class="btn bg-orange w-30px" @click="openDetail">
            <img src="../../../../assets/img/icon/plus-2.png" width="15" class="position-relative d-block mx-auto" style="left: -5px">
          </button>
        </div> -->
        <div class="text-right align-self-end" :class="{'col-4': qtyCart == 0 || !is_variant, 'col-5': qtyCart > 0 && is_variant}">
            <p v-if="qtyCart > 0 && is_variant" class="text-center w-100 mb-0 body-3-3 text-orange font-bold">({{qtyCart}}x)</p>
            <button type="button" class="button-secondary text-12 align-top py-1 px-3" v-if="qtyCart == 0 || is_variant" @click="changeQtyProduct('plus')">{{qtyCart == 0 ? $t('hotel.action.add') : $t('hotel.action.add-more')}}</button>
            <div class="row rounded-4 py-1 box-shadow-cart text-right w-100 no-gutters" v-if="!is_variant && qtyCart > 0">
              <div class="col-4 text-center cursor-pointer" @click="changeQtyProduct('minus')">
                <img src="../../../../assets/img/icon/minus-orange.png" width="14">
              </div>
              <div class="col-4 text-center">
                <p class="mb-0 body-2-4 position-relative" style="top: 3px;">{{qtyCart}}</p>
              </div>
              <div class="col-4 text-center cursor-pointer" @click="changeQtyProduct('plus')">
                <img src="../../../../assets/img/icon/plus-orange.png" width="14">
              </div>
            </div>
          </div>
      </div>
    </div>

    <popupWarningAddProduct v-if="show_popup" @close="show_popup = false"></popupWarningAddProduct>
  </div>
</template>
<script>
  import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js'
  import {mapGetters,mapMutations} from 'vuex';
  export default{
    props:['data'],
    data(){
      return{
        show_popup: false
      }
    },
    computed:{
      is_variant(){
        return this.data.variant_list.length == 0 ? false : true
      },
      base_price(){
        return this.is_variant ? this.data.variant_list[0].price : this.data.price
      },
      final_price(){
        return calculateFinalPriceConcierge(this.base_price)
      },
      promotion_price(){
        if(this.base_price.promotion_amount == 0){
          return 0
        }else{
          return this.base_price.tax_service_calculation_type == 'INCLUDE' ? (this.base_price.price_sell_base) : this.base_price.price_sell
        }
      },
      is_decrease_promo(){
        if(this.base_price.promotion_amount == 0){
          return false
        }else{
          return this.base_price.promotion_type == 'INCREASE' ? false : true

          // if(this.base_price.tax_service_calculation_type == 'INCLUDE'){
          //   if(this.base_price.price_sell+this.base_price.tax_amount+this.base_price.service_amount < this.base_price.price_sell_final){
          //     return false
          //   }else{
          //     return true
          //   }
          // }else{
          //   if(this.base_price.price_sell < this.base_price.price_sell_final){
          //     return false
          //   }else{
          //     return true
          //   }
          // }
        }
      },
      qtyCart(){
        let data = 0

        let record = this.getConciergeOrder().cart.findIndex(x=>x.product.data.product_id == this.data.product_id)
        if(record != -1){
          data = this.getConciergeOrder().cart[record].qty
        }

        return data
      }
    },
    methods:{
      ...mapGetters(['getMerchant','getConciergeOrder','getConciergeReservation']),
      ...mapMutations(['setConciergeOrder','removeConciergeOrder']),
      formatCurrency(value){
        return formatCurrency(value);
      },
      openDetail(){
        this.$emit('detail', this.data)
      },
      closePopup(){
        this.show_popup = false
      },
      changeQtyProduct(type){
        if(this.getConciergeReservation().status == 'CHECKIN'){
          if(type == 'plus' && this.is_variant){
            this.openDetail()
          }else{
            let params = {
              product: this.data,
              variant: {},
              qty: this.qtyCart
            }
            if(this.qtyCart == 1 && type == 'minus'){
              this.removeConciergeOrder(params)
            }else{
              if(type == 'minus'){
                params.qty--
              }else{
                params.qty++
              }
              this.setConciergeOrder(params)
            }
          }
        }else{
          this.show_popup = true
        }
      }
    }
  }
</script>
<style>
  .badge-variant{
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #000000b5;
    border-radius: 0px 0px 10px 10px;
    width: 100%;
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/menuSmallImage.vue